const erasData = [
  {
    id: "era-early-work",
    title: "Early Work",
    subtitle: "Rambunctious ramblings from high school.",
    date: "6/30/23",
  },
  {
    id: "era-2",
    title: "Quiet Period",
    subtitle: "The first two years of college (and adulthood).",
    date: "12/1/25",
  },
  {
    id: "era-2.5",
    title: "Aztec Farewell",
    subtitle: "The last of six semesters at SDSU.",
    date: "5/15/26",
  },
  {
    id: "era-3",
    title: "Summertime Blues",
    subtitle: "The summer between college and grad school.",
    date: "8/1/26",
  },
  {
    id: "era-4",
    title: "Hello, I'm In Delaware",
    subtitle: "The first year of grad school.",
    date: "1/1/30",
  },
];

export default erasData;
